// extracted by mini-css-extract-plugin
export default {"section":"Balance_section__f05yq","wrapPagination":"Balance_wrapPagination__D5SLl","goBack":"Balance_goBack__d5ZAV"};